"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.todayInPST = exports.toDateString = exports.toMoment = exports.nowInPST = void 0;
var moment = __importStar(require("moment"));
function nowInPST() {
    return moment.utc().utcOffset('-08:00').toISOString();
}
exports.nowInPST = nowInPST;
function toMoment(dateString) {
    return moment.default(dateString);
}
exports.toMoment = toMoment;
function toDateString(momentDate) {
    return momentDate.clone().startOf('day').format('YYYY-MM-DD');
}
exports.toDateString = toDateString;
function todayInPST() {
    return toDateString(moment.utc().utcOffset('-08:00'));
}
exports.todayInPST = todayInPST;
//# sourceMappingURL=TimeUtils.js.map